import { CompositeLayer, MVTLayer } from "deck.gl";
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions";
import { linearScale } from "../singleLayer/renderLayerService";

export class DSInSARLayer extends CompositeLayer {
    name = "xxx";
    componentName = "xxx";
    workspace = "";
    layerName = "";
    is3D = false;
    domain = [-27.559000225067138, -8.5, 1.399999976158142]
    range = [[255, 0, 0], [255, 255, 0], [0, 0, 255]]
    opacity = 1

    constructor(workspace, layerName, is3D, opacity) {
        super();

        this.workspace = workspace;
        this.layerName = layerName;
        this.is3D = is3D;
        this.opacity = opacity
    }

    shouldUpdateState({ changeFlags }) {
        return changeFlags.somethingChanged;
    }

    renderLayers() {
        const { zoom } = this.context.viewport;
        const dataSource = generateUrlGeoserverVector(this.workspace, this.layerName)

        return [
            new MVTLayer({
                id: 'AdmninistrativeDayPop',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                filled: true,
                stroke: true,
                //extruded: this.is3D,
                // wireframe: false,
                getLineColor: f => linearScale(f.properties.v_los, this.domain, this.range),
                getFillColor: f => linearScale(f.properties.v_los, this.domain, this.range),
                updateTriggers: {
                    opacity: this.opacity,
                    getFillColor: this.opacity,
                },
                getLineWidth: 100,
                lineWidthMinPixels: 1.0,
                pickable: true,
                terrainDrawMode: this.is3D ? 'offset' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],
                dataComparator: (a, b) => false
            }),
        ]
    }
}